import React, { useState, useEffect } from "react";
import { useHistory, useLocation } from "react-router-dom";

import {
  buildUsersUri,
  buildAdviseesUri,
  buildPoliciesUri,
  buildGlobalSettingUri,
  buildFinportGoalsUri,
  buildSettingUri,
  buildLeadDashboardUri,
  buildEmergencyContactUri,
  buildManageEmergencyContactTemplateUri,
  buildDashboardUri,
} from "utils/routes";
import { withAppContext } from "contexts/AppContext/AppContext";

import IconActivePolicies from "./icons/PoliciesActive.svg";
import IconNonActivePolicies from "./icons/PoliciesNonActive.svg";
import IconActiveAdvisees from "./icons/AdviseesActive.svg";
import IconNonActiveAdvisees from "./icons/AdviseesNonActive.svg";
import IconActiveUsers from "./icons/UsersActive.svg";
import IconNonActiveUsers from "./icons/UsersNonActive.svg";
import IconActiveSettings from "./icons/SettingsActive.svg";
import IconNonActiveSettings from "./icons/SettingsNonActive.svg";
import {
  UsergroupAddOutlined,
  IdcardOutlined,
  AreaChartOutlined,
  GlobalOutlined,
  FireOutlined,
} from "@ant-design/icons";

import {
  MainMenuItem,
  MenuItemContainer,
  MenuItemIcon,
  MenuItemLabel,
} from "./MainMenuNavBar.styles";

import { getUserAuthObj } from "utils/auth";

import Locale from "react-intl-universal";

const MainMenuNavBar = ({
  isAdmin,
  isFree,
  isAgentEntry,
  isAgentFull,
  isLeader,
  isContributor,
  isAgentFullAndContributor,
  getLoggedInUserSubscription,
}) => {
  const history = useHistory();
  const currentLocation = useLocation().pathname;

  const [userSubscription, setUserSubscription] = useState([]);

  const jwt = getUserAuthObj();

  useEffect(() => {
    console.log("role isAdmin", isAdmin);
    console.log("role isFree", isFree);
    console.log("role isAgentEntry", isAgentEntry);
    console.log("role isAgentFull", isAgentFull);
    console.log("role isLeader", isLeader);
    console.log("role isContributor", isContributor);
    console.log("role isAgentFullAndContributor", isAgentFullAndContributor);

    getCurrentSubscription();
    return () => {};
  }, []);

  const getCurrentSubscription = async () => {
    const currentSubscription = await getLoggedInUserSubscription();
    setUserSubscription(currentSubscription);
  };

  const menuItems = [
    ...(isAdmin ||
    isFree ||
    isAgentEntry ||
    isAgentFull ||
    isLeader ||
    // isContributor ||
    isAgentFullAndContributor
      ? [
          {
            antdIcon: currentLocation.startsWith(buildDashboardUri()) ? (
              <AreaChartOutlined style={{ fontSize: 32 }} />
            ) : (
              <AreaChartOutlined style={{ fontSize: 32 }} />
            ),
            label: Locale.get("Dashboard.pageTitle"),
            isActive: currentLocation.startsWith(buildDashboardUri()),
            onClick: () => history.push(buildDashboardUri()),
          },
        ]
      : []),

    ...(isAdmin
      ? //   ||
        // isFree ||
        // isAgentEntry ||
        // isAgentFull ||
        // isLeader ||
        // isContributor ||
        // isAgentFullAndContributor
        [
          {
            icon: currentLocation.startsWith(buildUsersUri())
              ? IconActiveUsers
              : IconNonActiveUsers,
            label: Locale.get("Users.pageTitle"),
            isActive: currentLocation.startsWith(buildUsersUri()),
            onClick: () => history.push(buildUsersUri()),
          },
        ]
      : []),

    ...(isAdmin || (!isContributor && userSubscription.length > 0)
      ? [
          {
            icon: currentLocation.startsWith(buildAdviseesUri())
              ? IconActiveAdvisees
              : IconNonActiveAdvisees,
            label: Locale.get("Advisees.pageTitle"),
            isActive: currentLocation.startsWith(buildAdviseesUri()),
            onClick: () => history.push(buildAdviseesUri()),
          },
        ]
      : []),

    ...(isAdmin ||
    ((isAgentFull || isLeader || isAgentFullAndContributor) &&
      userSubscription.length > 0)
      ? [
          {
            // check this at menuitems.map for icon use

            // icon: currentLocation.startsWith(buildLeadDashboardUri()) ? (
            //   <UsergroupAddOutlined />
            // ) : (
            //   <UsergroupAddOutlined />
            // ),
            label: Locale.get("leadDashboard.pageTitle"),
            isActive: currentLocation.startsWith(buildLeadDashboardUri()),
            onClick: () => history.push(buildLeadDashboardUri()),
          },
        ]
      : []),

    ...(isAdmin ||
    ((isAgentFull || isLeader || isContributor || isAgentFullAndContributor) &&
      userSubscription.length > 0)
      ? [
          {
            icon: currentLocation.startsWith(buildPoliciesUri())
              ? IconActivePolicies
              : IconNonActivePolicies,
            label: Locale.get("Policies.pageTitle"),
            isActive: currentLocation.startsWith(buildPoliciesUri()),
            onClick: () => history.push(buildPoliciesUri()),
          },
        ]
      : []),

    ...(isAdmin ||
    ((isFree ||
      isAgentEntry ||
      isAgentFull ||
      isLeader ||
      isContributor ||
      isAgentFullAndContributor) &&
      userSubscription.length > 0)
      ? [
          {
            icon: currentLocation.startsWith(buildSettingUri())
              ? IconActiveSettings
              : IconNonActiveSettings,
            label: Locale.get("Settings.iconLabel"),
            isActive: currentLocation.startsWith(buildSettingUri()),
            onClick: () => history.push(buildSettingUri()),
          },
        ]
      : []),

    ...(isAdmin
      ? [
          {
            antdIcon: currentLocation.startsWith(buildGlobalSettingUri()) ? (
              <GlobalOutlined style={{ fontSize: 32 }} />
            ) : (
              <GlobalOutlined style={{ fontSize: 32 }} />
            ),
            label: Locale.get("Settings.gsIconLabel"),
            isActive: currentLocation.startsWith(buildGlobalSettingUri()),
            onClick: () => history.push(buildGlobalSettingUri()),
          },
        ]
      : []),

    ...(isAdmin
      ? [
          {
            antdIcon: currentLocation.startsWith(buildFinportGoalsUri()) ? (
              <FireOutlined style={{ fontSize: 32 }} />
            ) : (
              <FireOutlined style={{ fontSize: 32 }} />
            ),
            label: Locale.get("finportGoal.pageTitle"),
            isActive: currentLocation.startsWith(buildFinportGoalsUri()),
            onClick: () => history.push(buildFinportGoalsUri()),
          },
        ]
      : []),

    ...(isAdmin || (!isContributor && userSubscription.length > 0)
      ? [
          {
            antdIcon:
              currentLocation.startsWith(buildEmergencyContactUri()) ||
              currentLocation.startsWith(
                buildManageEmergencyContactTemplateUri()
              ) ? (
                <IdcardOutlined style={{ fontSize: 32 }} />
              ) : (
                <IdcardOutlined style={{ fontSize: 32 }} />
              ),
            label: Locale.get("emergencyContact.pageTitle"),
            isActive:
              currentLocation.startsWith(buildEmergencyContactUri()) ||
              currentLocation.startsWith(
                buildManageEmergencyContactTemplateUri()
              ),
            onClick: () => history.push(buildEmergencyContactUri()),
          },
        ]
      : []),
  ];

  return menuItems.map((menuItem) => (
    <MainMenuItem justify="center" align="middle" key={menuItem.label}>
      <MenuItemContainer
        isActive={menuItem.isActive}
        onClick={menuItem.onClick}
      >
        {menuItem.label === "New Advisee" ||
        menuItem.label === Locale.get("leadDashboard.pageTitle") ? (
          <UsergroupAddOutlined style={{ fontSize: 32 }} />
        ) : menuItem.antdIcon ? (
          menuItem.antdIcon
        ) : (
          <MenuItemIcon
            src={menuItem.icon}
            width="32px"
            height="32px"
            alt={`${menuItem.label} Icon`}
          />
        )}

        <MenuItemLabel>{menuItem.label}</MenuItemLabel>
      </MenuItemContainer>
    </MainMenuItem>
  ));
};

export default withAppContext(MainMenuNavBar);
